<div
  (click)="toggleExpanded($event)"
  class="ui-inputtext ui-widget flex justify-content-between cursor-pointer ng-dirty"
  [class.expanded]="expanded"
  [class.unexpanded]="!expanded"
  [class.ng-invalid]="invalid"
  style="height: 20.5px"
  tabindex="0"
>
  <span>{{ text }}</span>
  <span class="ui-dropdown-trigger-icon ui-clickable pi pi-chevron-down"></span>
</div>
